import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LanguageContext = createContext(null);
const cache = {};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("nl-lang") || "fr");
  const [content, setContent] = useState(cache[lang] || null);
  const [loading, setLoading] = useState(!cache[lang]);
  const [config, setConfig] = useState({ contact_email: "" });

  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    let alive = true;
    if (cache[lang]) { setContent(cache[lang]); setLoading(false); }
    else setLoading(true);
    axios.get(`${API}/content`, { params: { lang } }).then((r) => {
      cache[lang] = r.data;
      if (alive) { setContent(r.data); setLoading(false); }
    }).catch(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [lang]);

  const setLang = useCallback((l) => { localStorage.setItem("nl-lang", l); setLangState(l); }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    const desc = content?.home?.hero?.text;
    if (desc) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", desc);
    }
  }, [lang, content]);

  const value = useMemo(() => ({ lang, setLang, content, loading, config, api: API }), [lang, setLang, content, loading, config]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
